import React from "react";
import { Box, Float, Typography, Button, Divider } from "digiwash-components";
import AddressesCard from "../containers/AddressesCard";
import Header from "../components/AppHeader";
import PageContainer from "../components/PageContainer";

import Icon from "../components/Icon";
import { SafeAreaView, Platform } from "react-native";
import useNavigation from "../hooks/useNavigation";
import { Helmet } from "react-helmet";
import { iosSafeArePadding } from "../helpers/general";
import HeaderContainer from "../containers/HeaderContainer";

const safeAreStyles = {
  paddingBottom: 24,
  background: "white",
};

let webStyles =
  Platform.OS === "web"
    ? {
        container: {
          maxWidth: 768,
          marginRight: "auto",
          marginLeft: "auto",
          width: "100%",
        },
      }
    : { container: {} };
let Container = Platform.OS === "web" ? Box : SafeAreaView;

function UserAddressesList() {
  let nav = useNavigation();
  return (
    <>
      <Helmet>
        <title>آدرس ها | دیجی واش</title>
      </Helmet>
      <PageContainer
        bg="common.white"
        afterScrollView={
          <>
            <Float px="xxl" fullWidth>
              <Container style={{ ...safeAreStyles, ...webStyles.container }}>
                <Box
                  style={{
                    width: "100%",
                    paddingBottom: iosSafeArePadding(),
                  }}
                  bg="common.white"
                >
                  <Button
                    outline
                    size="l"
                    prefix={<Icon name="plus" color="primary.main" size={16} />}
                    onPress={() => {
                      nav.navigate("NewAddress");
                    }}
                  >
                    اضافه کردن آدرس جدید
                  </Button>
                </Box>
              </Container>
            </Float>
          </>
        }
        insideBeignScrollView={
          <HeaderContainer>
            <Header
              title="آدرس ها"
              onBack={() => {
                nav.goBack();
              }}
            />
          </HeaderContainer>
        }
      >
        <Box pt="xxl" px="xxl">
          <Box px="m">
            <Typography color="common.black" ff="mainBold" fs="l">
              آدرس های ثبت شده
            </Typography>
          </Box>
          <Divider size="l" />
          <AddressesCard />
        </Box>
        <Divider size="xxxl" />
      </PageContainer>
    </>
  );
}

export default UserAddressesList;
